import { Component, OnInit } from '@angular/core';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { LoadingService } from '@core/services/loading.service';
import { PolicyService } from '@core/services/policy.service';
import { PoliciesOverviewComponent } from '../policies-overview.component';

@Component({
  selector: 'app-policy-b2b-lease',
  templateUrl: './policy-b2b-lease.component.html',
  styleUrls: ['./policy-b2b-lease.component.scss'],
  standalone: false
})
export class PolicyB2bLeaseComponent extends PoliciesOverviewComponent implements OnInit {

  constructor(
    public commonService: CommonService,
    protected dataService: DataService,
    protected policyService: PolicyService,
    protected loadingService: LoadingService
  ) {
    super(commonService, dataService, policyService, loadingService);
   }

   ngOnInit(): void {
    super.ngOnInit();

    this.policyService.getActivePolicies().subscribe(res => {
      this.activePolicies = res;
    });
   }

}

